<div class="flip-container card-wrapper" [ngClass]="{ rotate: rotate }">
  <div class="flipper card-rotating effect__click tp-box">
    <ng-content></ng-content>
  </div>
</div>
